import React from 'react'
import { LIBERTY_IMAGES } from '../assets/asset'

export function shortenAddress(address) {
    if (!address || address.length < 12) return address
    return `${address.slice(0, 6)}...${address.slice(-4)}`
}

export function filterTokenList(list, query) {
    const q = query.trim().toLowerCase()
    if (!q) return list
    return list.filter((t) => {
        const sym = (t.symbol || '').toLowerCase()
        const name = (t.name || '').toLowerCase()
        const addr = (t.address || '').toLowerCase()
        return sym.includes(q) || name.includes(q) || addr.includes(q)
    })
}

export function chainMeta(chainId) {
    switch (chainId) {
        case 1:
            return { label: 'Ethereum', badge: LIBERTY_IMAGES.ETHEREUM }
        case 56:
            return { label: 'BSC', badge: LIBERTY_IMAGES.BSC }
        case 42161:
            return { label: 'Arbitrum', badge: LIBERTY_IMAGES.ARBITRUM }
        case 8453:
            return { label: 'Base', badge: LIBERTY_IMAGES.BASE }
        case 369:
            return { label: 'PulseChain', badge: LIBERTY_IMAGES.PULSECHAIN }
        default:
            return { label: `Chain ${chainId}`, badge: LIBERTY_IMAGES.PULSECHAIN }
    }
}

/** Payload passed to parent when a list row is chosen */
export function toTokenSelection(token) {
    const chain = chainMeta(token.chainId)
    return {
        symbol: token.symbol,
        name: token.name,
        address: token.address,
        chainId: token.chainId,
        decimals: token.decimals,
        chain: chain.label,
        image: token.logoURI,
        chainBadge: chain.badge,
    }
}

export function TokenSelectorRows({ tokens, layout, infoIconSrc, onSelectRow, railgunBranding = false }) {
    return tokens.map((token) => {
        const chain = chainMeta(token.chainId)
        const key = `${token.chainId}-${token.address}`

        const iconBlock = (
            <div className="relative ">
                <img
                    alt={token.symbol}
                    loading="lazy"
                    width={36}
                    height={36}
                    decoding="async"
                    data-nimg={1}
                    className="border border-[#393941] rounded-full"
                    src={token.logoURI}
                    style={{ color: 'transparent' }}
                />
                <div className="absolute -bottom-1 -right-1">
                    <img
                        alt={chain.label}
                        loading="lazy"
                        width={16}
                        height={16}
                        decoding="async"
                        data-nimg={1}
                        className="border border-[#393941] rounded-full"
                        src={railgunBranding ? LIBERTY_IMAGES.IC_RAILGUN_LOG : chain.badge}
                        style={{ color: 'transparent' }}
                    />
                </div>
            </div>
        )

        const textBlock = (
            <div className="flex flex-col items-start min-w-0 flex-1">
                <span className="text-[#F7F7F8] font-medium text-base">
                    {token.symbol}
                    {railgunBranding && <span className="text-[#F5A425]"> · RAILGUN</span>}
                </span>
                <div className="flex items-center gap-1 mt-0.5 text-[#9091A0] text-xs min-w-0">
                    <span className="truncate">{chain.label}</span>
                    <span className="mx-0.5">•</span>
                    <span className="font-mono truncate max-w-[90px]">{shortenAddress(token.address)}</span>
                    <span className="ml-1 cursor-pointer relative" tabIndex={-1}>
                        <button
                            type="button"
                            onClick={(e) => e.stopPropagation()}
                            className="p-1 hover:bg-[#393941] rounded transition-colors">
                            <img
                                alt="Token info"
                                loading="lazy"
                                width={16}
                                height={16}
                                decoding="async"
                                data-nimg={1}
                                src={infoIconSrc}
                                style={{ color: 'transparent' }}
                            />
                        </button>
                    </span>
                </div>
            </div>
        )

        const pick = () => onSelectRow?.(toTokenSelection(token))

        if (layout === 'default') {
            return (
                <div key={key}>
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={pick}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault()
                                pick()
                            }
                        }}
                        className="flex items-center gap-3 w-full py-1 px-2 rounded-2xl transition-colors duration-150 cursor-pointer hover:bg-[#ffffff]/10">
                        {iconBlock}
                        {textBlock}
                        <div className="hidden md:block" />
                    </div>
                    <div className="ml-14! block md:hidden" />
                </div>
            )
        }

        return (
            <div
                key={key}
                role="button"
                tabIndex={0}
                onClick={pick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        pick()
                    }
                }}
                className="flex items-center gap-3 w-full py-1 px-2 rounded-2xl transition-colors duration-150 cursor-pointer hover:bg-[#ffffff]/10 ">
                {iconBlock}
                {textBlock}
            </div>
        )
    })
}
